// extracted by mini-css-extract-plugin
export default {"footerBtns":"CancelLesson_footerBtns__7wYT+","mb16":"CancelLesson_mb16__WSIki","disclaimerSection":"CancelLesson_disclaimerSection__b8Go0"};